import React from "react";
import Nav from "../components/nav";
import "../css/hero.css";
import eventVideo from "../images/EEA25i.mp4";
import { FaPlay, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

const Hero = () => {
  return (
    <div className="hero-section">
      <div className="video-overlay"></div>
      <video autoPlay loop muted playsInline className="hero-video">
        <source src={eventVideo} type="video/mp4" />
      </video>

      <Nav />

      <div className="hero-content-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-highlight">Energy X Africa</span> 2026
            </h1>
            <p className="hero-subtitle">
              A breakthrough industry initiative connecting Southern Africa's
              just energy transition future
            </p>

            <div className="event-details">
              <div className="detail-item">
                <FaCalendarAlt className="detail-icon" />
                <span>Coming in   {'   '}2026</span>
              </div>
              <div className="detail-item">
                <FaMapMarkerAlt className="detail-icon" />
                <span>Mittah Seperepere Convention Centre, Kimberley</span>
              </div>
            </div>
          </div>

          <div className="hero-actions">
            <a
              href="https://m.youtube.com/watch?v=cJKrACbE6k0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="primary-btn">
                <FaPlay className="btn-icon" />
                Watch Trailer
              </button>
            </a>
            <a href="#register">
              <button className="secondary-btn">Register Now</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;